module.exports = __webpack_public_path__ + "img/006-underpants.ed9042c7.svg";